import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  CheckCircle as CheckIcon,
  ShoppingCart as CartIcon,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: 12,
      maxWidth: 420,
    },
  },
  title: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  titleIcon: {
    fontSize: 28,
  },
  content: {
    padding: theme.spacing(3),
  },
  totalBox: {
    backgroundColor: theme.palette.success.light,
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    textAlign: "center",
  },
  totalLabel: {
    fontSize: "0.875rem",
    color: theme.palette.success.dark,
    marginBottom: 4,
  },
  totalValue: {
    fontSize: "1.5rem",
    fontWeight: 700,
    color: theme.palette.success.dark,
  },
  checkList: {
    marginTop: theme.spacing(1),
  },
  checkItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
    fontSize: "0.9rem",
    color: theme.palette.text.secondary,
  },
  checkIcon: {
    fontSize: 20,
    color: theme.palette.success.main,
  },
  actions: {
    padding: theme.spacing(2, 3, 3),
    gap: theme.spacing(1),
  },
  confirmButton: {
    flex: 1,
    padding: theme.spacing(1.5),
    fontWeight: 600,
  },
  cancelButton: {
    color: theme.palette.text.secondary,
  },
}));

const PdvFinalizeConfirmModal = ({
  open,
  onClose,
  onConfirm,
  loading = false,
  orderTotal,
}) => {
  const classes = useStyles();

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value || 0);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.dialog}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle disableTypography className={classes.title}>
        <CartIcon className={classes.titleIcon} />
        <Typography variant="h6">Confirmar Venda</Typography>
      </DialogTitle>

      <DialogContent className={classes.content}>
        <Box className={classes.totalBox}>
          <Typography className={classes.totalLabel}>
            Total da venda
          </Typography>
          <Typography className={classes.totalValue}>
            {formatCurrency(orderTotal)}
          </Typography>
        </Box>

        <Typography variant="body2" style={{ fontWeight: 500, marginBottom: 12 }}>
          Ao confirmar:
        </Typography>

        <Box className={classes.checkList}>
          <Box className={classes.checkItem}>
            <CheckIcon className={classes.checkIcon} />
            <span>Resumo do pedido enviado ao cliente</span>
          </Box>
          <Box className={classes.checkItem}>
            <CheckIcon className={classes.checkIcon} />
            <span>Mensagem de agradecimento enviada</span>
          </Box>
          <Box className={classes.checkItem}>
            <CheckIcon className={classes.checkIcon} />
            <span>Venda registrada no sistema</span>
          </Box>
          <Box className={classes.checkItem}>
            <CheckIcon className={classes.checkIcon} />
            <span>Atendimento encerrado automaticamente</span>
          </Box>
        </Box>

        <Typography
          variant="caption"
          style={{
            display: "block",
            marginTop: 16,
            color: "#666",
            fontStyle: "italic"
          }}
        >
          Se precisar continuar a conversa, clique em Cancelar. O carrinho sera mantido.
        </Typography>
      </DialogContent>

      <DialogActions className={classes.actions}>
        <Button
          onClick={onClose}
          className={classes.cancelButton}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={classes.confirmButton}
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Finalizando..." : "Confirmar Venda"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PdvFinalizeConfirmModal;
